import { View, StyleSheet, ScrollView } from "react-native";
import { FileItem } from "../components/FileItem";
import { FileViewProps } from "../types";

export function IconsView({ files, onFileRemove, onFileRename, onFilePreview }: FileViewProps) {
  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.content}>
      <View style={styles.grid}>
        {files.map((file) => (
          <FileItem
            key={file.id}
            file={file}
            mode="icons"
            onRemove={onFileRemove ? () => onFileRemove(file.id) : undefined}
            onRename={onFileRename ? (newName) => onFileRename(file.id, newName) : undefined}
            onPreview={onFilePreview ? () => onFilePreview(file) : undefined}
          />
        ))}
      </View>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    flexGrow: 1,
  },
  grid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 12,
  },
});
